class AnimationSubsTextAndColumns {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSubsTextAndColumns = this.sectionsContainer.querySelectorAll('.subs-text-and-columns');
		
		if (!this.$moduleSubsTextAndColumns.length)
			return;
		
		this.$moduleSubsTextAndColumnsElements = [];
		this.$moduleSubsTextAndColumns.forEach(module => {
			this.$moduleSubsTextAndColumnsElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSubsTextAndColumns.forEach((module, index) => {
		    console.log(this.$moduleSubsTextAndColumnsElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSubsTextAndColumnsElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleSubsTextAndColumns = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSubsTextAndColumns[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSubsTextAndColumnsElements[index], { clearProps: true });
			}
        });

        moduleSubsTextAndColumns.addLabel('step1');
        moduleSubsTextAndColumns.to(this.$moduleSubsTextAndColumns[index], { opacity: 1, duration: 1 }, 'step1');
		moduleSubsTextAndColumns.to(this.$moduleSubsTextAndColumnsElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationSubsTextAndColumns;
